import { Component, Injector, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AsideUiEngineComponent } from '../components/aside-ui-engine/aside-ui-engine.component';
import { AsideBarService } from '../services/asideBar.service';

@Component({
    selector: 'app-multiple-form',
    templateUrl: './multiple-form.component.html',
    styleUrls: ['./multiple-form.component.scss'],
    standalone: false
})
export class MultipleFormComponent extends AsideUiEngineComponent implements OnInit {
  @Input() data: any;
  @ViewChildren('formRef') formRef: QueryList<any>;
  invalid: boolean;
  card_data: any;
  private gridDataSub: Subscription;
  constructor(public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public asideBarService: AsideBarService
  ) {
    super(injector, router, route, modal, asideBarService);
  }


  ngOnInit() {
    super.ngOnInit();
    this._currentData.bannerJson = this._currentData.currentFormFields.bannerJson;
    this.gridDataSub = this.asideBarService.gridData.subscribe(data => {
      this.card_data = data.map(obj => {
        let val;
        if (this.formRef != undefined && this.formRef['_results'] != undefined) {
          val = this.formRef['_results'].find(formObj => formObj.form != undefined && formObj.form.value != undefined ? formObj.form.value.id == obj.id : false);
        }
        if (val && val.form != undefined) {
          obj = val.form.value;
          if(obj.returnQty != ''){
            obj.set_data = true;
            obj['returnQty'] = (+obj['returnQty']);//emr specific have to be refactored
          }
        }
        // if (this._currentData.currentFormFields.blocks) {
        //   this._currentData.currentFormFields.blocks.forEach(element => {
        //     element.fields.forEach(element_ => {
        //       if (val && element_.proxy_name != undefined) {
        //         element_.proxy_name = element_.name;
        //         obj['availableReturnQty'] = obj['returnQty'];//emr specific have to be refactored
        //       }

        //     });
        //   });
        // }
        return obj;
      });
      setTimeout(() => {
        var tag =document.getElementsByTagName("app-multiple-form");
        if(tag && tag.length > 0){
          document.getElementsByTagName("app-multiple-form")[0].scrollTo({
            top: tag[0].scrollHeight,
            behavior: 'smooth'
          })
        }
      },1000);
    })
  }

  ngOnDestroy() {
    this.gridDataSub?.unsubscribe();
    super.ngOnDestroy();
  }

  getConfig(card, index) {
    let configForm = {
      "submitButton": false,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": '',
      'delta_update': false,
      "id": this._currentData.resouceDef.resource + index
    }
    return configForm
  }

  buttonClick(formCom) {
    console.log(formCom)
  }
  count: number = 0;
  onSaveFinished(val?) {
    if (this.count == 0) {
      this.loader.showSpinner();
      this.invalid = false
      if (this._currentData.decorator && this._currentData.decorator.submitRequest) {
        this.formRef['_results'].forEach(element => {
          const invalidControl = element.el.nativeElement.querySelector('.ng-invalid');
          if (invalidControl) {
            element.validIn = true;
            this.invalid = true
          }
        });
        if (this.invalid == false) {
          this.count = this.count + 1;
          this._currentData.decorator.submitRequest(this.formRef, this._currentData.resouceDef, (res) => {
            this.loader.hideSpinner();
            if(res)
            this.commonService.removeComponent(res, this._currentData.decorator);
            else 
            this.count = 0
          })
        } else
          this.loader.hideSpinner();
      }
      else {
        this.loader.hideSpinner();
        // Logic to be implemented in case of no decorator
        this.commonService.removeComponent();
      }
    }
  }

}
